import React from 'react'

export const UploaderOrigin = () => {
  return window.UPLOADER_ORIGIN || ""
}